<span class="description">
  {{ title | translate }}
</span>

<automata-automation-replacement-chips
  [label]="'CRM_FIELDS_DIALOG.CUSTOM_OBJECT_TYPE'"
  [dataService]="crmCustomObjectTypeSelectorService"
  [formControl]="customObjectTypeFormControl"
  [isRequired]="!isTemplateContext"
  [multiple]="false"
  [supportDataPassing]="false"
  (finishedInitialLoading)="finishedLoadingSelector()"
></automata-automation-replacement-chips>

@if (rerenderReplacementChipsTrigger() && hasObjectTypeSelected()) {
  <automata-automation-replacement-chips
    label="AUTOMATIONS.COMMON.LIST"
    [dataService]="listService"
    [formControl]="listNameControl"
    [isRequired]="!isTemplateContext"
    [multiple]="false"
    [supportDataPassing]="false"
    [extraData]="{
      crmObjectSubtype: customObjectTypeFormControl.value,
    }"
  ></automata-automation-replacement-chips>
}
